import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountService, SubscriptionType } from 'src/app/services/account/account.service';
import { LanguageService } from 'src/app/services/account/language.service';

@Component({
  standalone: true,
  selector: 'app-subscription-delete-dialog',
  imports: [],
  templateUrl: './subscription-delete-dialog.component.html',
  styleUrl: './subscription-delete-dialog.component.scss'
})
export class SubscriptionDeleteDialogComponent {

  public type: SubscriptionType;
  public deleteSubscriptionDescription: string;
  public sorryToSeeYouLeaveMessage: string;

  constructor(public dialogRef: MatDialogRef<SubscriptionDeleteDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    public languageService: LanguageService, private accountService: AccountService) {

    this.type = this.data.subscriptionType.SubscriptionType;

    const subscriptionType = this.type?.includes('proplus.') ? "PRO<small>+</small>" : "PRO";
    this.deleteSubscriptionDescription = this.languageService.languageJSON.SubscriptionsDialog_DeleteSubscriptionDescription.replace("$subscriptionType", subscriptionType);

    const daysLeft = this.calculateDaysLeft(this.data.subscriptionType.ExpireDate);
    this.sorryToSeeYouLeaveMessage = this.languageService.languageJSON.SubscriptionsDialog_WereSorryToSeeYouLeave.replaceAll("$days", daysLeft.toString());
  }

  private calculateDaysLeft(expireDate: Date | string): number {
    if (!expireDate) {
      return 0;
    }
    const expire = new Date(expireDate).getTime();
    const now = Date.now();
    const diffMs = expire - now;
    return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
  }

  public close(): void {
    this.dialogRef.close({ delete: false });
  }

  public delete(): void {
    this.dialogRef.close({ delete: true });
  }
}
